export const ThreeDots = () => {
    return `
        width: inherit;
        overflow: hidden;
        text-overflow: ellipsis;
    `
}
